function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateMedia(html) {
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
          );

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateMedia(html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (!addButton.hasAttribute('data-build-your-own-kit-picker')) {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

/**
 * Injects Loop widget free-bonus block below .loop-widget-spg-container
 * Only on product pages; fetches fragrance product data and builds the block.
 */
(function initLoopWidgetFreeBonus() {
  if (!document.querySelector('#MainProduct') && !document.querySelector('[id^="MainProduct-"]')) return;

  var freeBonusInjected = false;
  var freeBonusOnetimeInjected = false;
  var freeBonusPending = false;
  var tipsRowInjected = false;
  var purchaseOptionBadgeInjected = false;
  var labelObserveInterval = 0;

  function injectPurchaseOptionBadge() {
    if (purchaseOptionBadgeInjected) return;
    var pathname = typeof window.location !== 'undefined' && window.location.pathname ? window.location.pathname : '';
    if (pathname.indexOf('/products/build-your-own-kit-4') === -1 && pathname.indexOf('/products/build-your-own-kit-3') === -1 && pathname.indexOf('/products/build-your-own-kit-2') === -1) return;
    var firstOption = document.querySelector('.loop-widget-purchase-option');
    if (!firstOption || firstOption.querySelector('.loop-widget-purchase-option-badge')) return;
    var badgeText = pathname.indexOf('/products/build-your-own-kit-4') !== -1 ? 'Get 2 Free Gifts' : 'Get 1 Free Gift';
    var badge = document.createElement('span');
    badge.className = 'bundle-size-selector__badge loop-widget-purchase-option-badge';
    badge.textContent = badgeText;
    firstOption.style.position = 'relative';
    firstOption.appendChild(badge);
    purchaseOptionBadgeInjected = true;
  }

  var customLiMarkerSvg = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="20" rx="10" fill="#EF7D9F"/><path d="M16 6.97586L14.7654 6L10.0869 10.6415L9.49844 11.795L10.0869 12.8422L16 6.97586Z" fill="white"/><path d="M5.17016 8.60708L4 9.64332L8.91987 14L10.0869 12.8422V10.6415L8.85158 11.867L5.17016 8.60708Z" fill="white"/></svg>';

  function injectTipsRow() {
    if (tipsRowInjected) return;
    var btnContainer = document.querySelector('.loop-widget-sp-button-container');
    if (!btnContainer || btnContainer.previousElementSibling?.classList.contains('loop-widget-tips-row')) return;
    var wrap = document.createElement('div');
    wrap.className = 'loop-widget-tips-row';
    wrap.innerHTML =
      '<div class="loop-widget-tips-row__item">' +
      '<span class="loop-widget-tips-row__icon">' + customLiMarkerSvg + '</span>' +
      '<span class="loop-widget-tips-row__text">Cancel, pause and change anytime</span>' +
      '</div>' +
      '<div class="loop-widget-tips-row__item">' +
      '<span class="loop-widget-tips-row__icon">' + customLiMarkerSvg + '</span>' +
      '<span class="loop-widget-tips-row__text">Fast door-to-door delivery</span>' +
      '</div>';
    btnContainer.parentNode.insertBefore(wrap, btnContainer);
    tipsRowInjected = true;
  }

  var loopFreeBonusPlusSvg = '<svg width="12" height="12" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.232 12.024V6.72H0V5.304H5.232V0H6.816V5.304H12.048V6.72H6.816V12.024H5.232Z" fill="#142D63"/></svg>';

  function injectFreeBonus() {
    if (freeBonusInjected || freeBonusPending) return;
    if (document.querySelector('.loop-widget-free-bonus')) return;

    const container = document.querySelector('.loop-widget-spg-container');
    if (!container || container.nextElementSibling?.classList.contains('loop-widget-free-bonus')) return;

    const isBuildYourOwnKit4 = typeof window.location !== 'undefined' && window.location.pathname && window.location.pathname.indexOf('/products/build-your-own-kit-4') !== -1;

    freeBonusPending = true;

    // Prefer sharp image and price from existing add-on row (same as bundle)
    let imgSrc = '';
    let priceFormattedFromDom = '';
    const existingImg = document.querySelector('.bundle-selector__row-image[alt="Linen Air Freshener (50ml)"]');
    if (existingImg && existingImg.src) {
      imgSrc = existingImg.src.replace(/([?&])width=\d+/, '$1width=120');
      if (imgSrc === existingImg.src) imgSrc = existingImg.src + (existingImg.src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
    }
    if (existingImg) {
      var fragranceRow = existingImg.closest('.bundle-selector__row');
      if (fragranceRow) {
        var fragrancePriceEl = fragranceRow.querySelector('.build-your-own-kit-add-on__price-current');
        if (fragrancePriceEl) priceFormattedFromDom = fragrancePriceEl.textContent.trim();
      }
    }

    var fragrancePromise = fetch('/products/fragrance.json').then(function (res) { return res.ok ? res.json() : null; });
    var cleaningClothsPromise = isBuildYourOwnKit4 ? fetch('/products/cleaning-cloths-pack.json').then(function (res) { return res.ok ? res.json() : null; }) : Promise.resolve(null);

    Promise.all([fragrancePromise, cleaningClothsPromise])
      .then(function (results) {
        if (freeBonusInjected || document.querySelector('.loop-widget-free-bonus')) {
          freeBonusPending = false;
          return;
        }
        var data = results[0];
        var cleaningClothsData = results[1];
        const p = data?.product || data;
        if (!p) {
          freeBonusPending = false;
          return;
        }

        if (!imgSrc) {
          const img = p.featured_image || (p.images && p.images[0]);
          if (img) {
            imgSrc = typeof img === 'string' ? img : (img.src || img.url || '');
            if (imgSrc) imgSrc = imgSrc + (imgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=120';
          }
        }

        var priceFormatted = priceFormattedFromDom;
        if (!priceFormatted) {
          const variant = p.variants?.[0];
          const comparePriceVal = variant?.compare_at_price ?? variant?.price ?? p.compare_at_price ?? p.price;
          let priceNum = comparePriceVal != null ? Number(comparePriceVal) : NaN;
          if (isNaN(priceNum)) priceNum = 0;
          const displayValue = priceNum >= 100 ? priceNum / 100 : priceNum;
          priceFormatted = displayValue > 0 ? '£' + displayValue.toFixed(2) : '';
        }

        var innerHtml =
          '<p class="loop-widget-free-bonus__heading">' +
          '<span class="loop-widget-free-bonus__heading-accent">Free bonus</span> with subscription:</p>' +
          '<div class="loop-widget-free-bonus__content">' +
          '<img class="loop-widget-free-bonus__image" src="' + (imgSrc || '').replace(/"/g, '&quot;') + '" width="60" height="60" alt="Fragrance for Cleaning Products">' +
          '<div class="loop-widget-free-bonus__text-block">' +
          '<div class="loop-widget-free-bonus__title">Linen Air Freshener <span style="font-weight: 700;">(50ml, included with every delivery)</span></div>' +
          '<div class="loop-widget-free-bonus__desc">Highly effective with odour-capture technology, it locks in bad smells from the air and soft furnishings.</div>' +
          '<div class="loop-widget-free-bonus__price-row">' +
          '<span class="loop-widget-free-bonus__free">FREE</span>' +
          (priceFormatted ? '<span class="loop-widget-free-bonus__compare-price">' + priceFormatted + '</span>' : '') +
          '</div></div></div>';

        if (isBuildYourOwnKit4 && cleaningClothsData) {
          var clothsProduct = cleaningClothsData.product || cleaningClothsData;
          var clothsImgSrc = '';
          var clothsPriceFormatted = '';
          var clothsImgEl = document.querySelector('.bundle-selector__row-image[alt="Pack of 3 Cleaning Cloths"]');
          if (clothsImgEl && clothsImgEl.src) {
            clothsImgSrc = clothsImgEl.src.replace(/([?&])width=\d+/, '$1width=120');
            if (clothsImgSrc === clothsImgEl.src) clothsImgSrc = clothsImgEl.src + (clothsImgEl.src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
          }
          if (clothsImgEl) {
            var clothsRow = clothsImgEl.closest('.bundle-selector__row');
            if (clothsRow) {
              var clothsPriceEl = clothsRow.querySelector('.build-your-own-kit-add-on__price-current');
              if (clothsPriceEl) clothsPriceFormatted = clothsPriceEl.textContent.trim();
            }
          }
          if (!clothsImgSrc && clothsProduct) {
            var clothsImg = clothsProduct.featured_image || (clothsProduct.images && clothsProduct.images[0]);
            if (clothsImg) {
              clothsImgSrc = typeof clothsImg === 'string' ? clothsImg : (clothsImg.src || clothsImg.url || '');
              if (clothsImgSrc) clothsImgSrc = clothsImgSrc + (clothsImgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=120';
            }
          }
          if (!clothsPriceFormatted && clothsProduct) {
            var clothsVariant = clothsProduct.variants && clothsProduct.variants[0];
            var clothsCompareVal = clothsVariant && (clothsVariant.compare_at_price != null ? clothsVariant.compare_at_price : clothsVariant.price);
            if (clothsCompareVal == null && clothsProduct) clothsCompareVal = clothsProduct.compare_at_price || clothsProduct.price;
            var clothsPriceNum = clothsCompareVal != null ? Number(clothsCompareVal) : NaN;
            if (isNaN(clothsPriceNum)) clothsPriceNum = 0;
            var clothsDisplayValue = clothsPriceNum >= 100 ? clothsPriceNum / 100 : clothsPriceNum;
            clothsPriceFormatted = clothsDisplayValue > 0 ? '£' + clothsDisplayValue.toFixed(2) : '';
          }

          innerHtml +=
            '<span class="loop-widget-free-bonus__plus">' + loopFreeBonusPlusSvg + '</span>' +
            '<div class="loop-widget-free-bonus__content">' +
            '<img class="loop-widget-free-bonus__image" src="' + (clothsImgSrc || '').replace(/"/g, '&quot;') + '" width="60" height="60" alt="Pack of 3 Cleaning Cloths">' +
            '<div class="loop-widget-free-bonus__text-block">' +
            '<div class="loop-widget-free-bonus__title">Pack of 3 Cleaning Cloths</div>' +
            '<div class="loop-widget-free-bonus__desc">Reusable microfiber cloths for safe and effective cleaning: pink for the sink, blue for the loo.</div>' +
            '<div class="loop-widget-free-bonus__price-row">' +
            '<span class="loop-widget-free-bonus__free">FREE</span>' +
            (clothsPriceFormatted ? '<span class="loop-widget-free-bonus__compare-price">' + clothsPriceFormatted + '</span>' : '') +
            '</div></div></div>';
        }

        const wrap = document.createElement('div');
        wrap.className = 'loop-widget-free-bonus';
        wrap.innerHTML = innerHtml;

        const target = document.querySelector('.loop-widget-spg-container');
        if (target && !target.nextElementSibling?.classList.contains('loop-widget-free-bonus')) {
          target.insertAdjacentElement('afterend', wrap);
          freeBonusInjected = true;
        }

        if (isBuildYourOwnKit4 && !freeBonusOnetimeInjected) {
          var onetimeHeader = document.querySelector('.loop-widget-purchase-option-onetime .loop-widget-purchase-option-header');
          if (onetimeHeader && !onetimeHeader.nextElementSibling?.classList.contains('loop-widget-free-bonus')) {
            var onetimeInnerHtml =
              '<p class="loop-widget-free-bonus__heading">' +
              '<span class="loop-widget-free-bonus__heading-accent">Free one-time bonus:</span></p>' +
              '<div class="loop-widget-free-bonus__content">' +
              '<img class="loop-widget-free-bonus__image" src="' + (imgSrc || '').replace(/"/g, '&quot;') + '" width="60" height="60" alt="Fragrance for Cleaning Products">' +
              '<div class="loop-widget-free-bonus__text-block">' +
              '<div class="loop-widget-free-bonus__title">Linen Air Freshener (50ml)</div>' +
              '<div class="loop-widget-free-bonus__desc">Highly effective with odour-capture technology, it locks in bad smells from the air and soft furnishings.</div>' +
              '<div class="loop-widget-free-bonus__price-row">' +
              '<span class="loop-widget-free-bonus__free">FREE</span>' +
              (priceFormatted ? '<span class="loop-widget-free-bonus__compare-price">' + priceFormatted + '</span>' : '') +
              '</div></div></div>';
            if (cleaningClothsData) {
              var clothsProduct = cleaningClothsData.product || cleaningClothsData;
              var clothsImgSrc = '';
              var clothsPriceFormatted = '';
              var clothsImgEl = document.querySelector('.bundle-selector__row-image[alt="Pack of 3 Cleaning Cloths"]');
              if (clothsImgEl && clothsImgEl.src) {
                clothsImgSrc = clothsImgEl.src.replace(/([?&])width=\d+/, '$1width=120');
                if (clothsImgSrc === clothsImgEl.src) clothsImgSrc = clothsImgEl.src + (clothsImgEl.src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
              }
              if (clothsImgEl) {
                var clothsRow = clothsImgEl.closest('.bundle-selector__row');
                if (clothsRow) {
                  var clothsPriceEl = clothsRow.querySelector('.build-your-own-kit-add-on__price-current');
                  if (clothsPriceEl) clothsPriceFormatted = clothsPriceEl.textContent.trim();
                }
              }
              if (!clothsImgSrc && clothsProduct) {
                var clothsImg = clothsProduct.featured_image || (clothsProduct.images && clothsProduct.images[0]);
                if (clothsImg) {
                  clothsImgSrc = typeof clothsImg === 'string' ? clothsImg : (clothsImg.src || clothsImg.url || '');
                  if (clothsImgSrc) clothsImgSrc = clothsImgSrc + (clothsImgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=120';
                }
              }
              if (!clothsPriceFormatted && clothsProduct) {
                var clothsVariant = clothsProduct.variants && clothsProduct.variants[0];
                var clothsCompareVal = clothsVariant && (clothsVariant.compare_at_price != null ? clothsVariant.compare_at_price : clothsVariant.price);
                if (clothsCompareVal == null && clothsProduct) clothsCompareVal = clothsProduct.compare_at_price || clothsProduct.price;
                var clothsPriceNum = clothsCompareVal != null ? Number(clothsCompareVal) : NaN;
                if (isNaN(clothsPriceNum)) clothsPriceNum = 0;
                var clothsDisplayValue = clothsPriceNum >= 100 ? clothsPriceNum / 100 : clothsPriceNum;
                clothsPriceFormatted = clothsDisplayValue > 0 ? '£' + clothsDisplayValue.toFixed(2) : '';
              }
              onetimeInnerHtml +=
                '<span class="loop-widget-free-bonus__plus">' + loopFreeBonusPlusSvg + '</span>' +
                '<div class="loop-widget-free-bonus__content">' +
                '<img class="loop-widget-free-bonus__image" src="' + (clothsImgSrc || '').replace(/"/g, '&quot;') + '" width="60" height="60" alt="Pack of 3 Cleaning Cloths">' +
                '<div class="loop-widget-free-bonus__text-block">' +
                '<div class="loop-widget-free-bonus__title">Pack of 3 Cleaning Cloths</div>' +
                '<div class="loop-widget-free-bonus__desc">Reusable microfiber cloths for safe and effective cleaning: pink for the sink, blue for the loo.</div>' +
                '<div class="loop-widget-free-bonus__price-row">' +
                '<span class="loop-widget-free-bonus__free">FREE</span>' +
                (clothsPriceFormatted ? '<span class="loop-widget-free-bonus__compare-price">' + clothsPriceFormatted + '</span>' : '') +
                '</div></div></div>';
            }
            var onetimeWrap = document.createElement('div');
            onetimeWrap.className = 'loop-widget-free-bonus';
            onetimeWrap.innerHTML = onetimeInnerHtml;
            onetimeHeader.insertAdjacentElement('afterend', onetimeWrap);
            freeBonusOnetimeInjected = true;
          }
        }

        freeBonusPending = false;
      })
      .catch(function () {
        freeBonusPending = false;
      });
  }

  function updateLoopSelectorLabel() {
    var label = document.querySelector('[id^="loop-widget-sp-button-selector-label-"]');
    if (!label) label = document.querySelector('.loop-widget-sp-button-selector-label');
    var priceEl = document.querySelector('.loop-widget-purchase-option-price');
    var selectedBtn = document.querySelector('.loop-widget-sp-button-selected');
    if (!label) return;
    var original = label.getAttribute('data-loop-original-label');
    if (original == null) {
      original = label.textContent || '';
      label.setAttribute('data-loop-original-label', original);
    }
    var priceText = priceEl ? priceEl.textContent.trim() : '';
    if (priceText.indexOf('.') !== -1) priceText = priceText.split('.')[0];
    var selectedText = selectedBtn ? selectedBtn.textContent.trim() : '';
    var text = original.replace(/£(?=\s)/g, priceText);
    text = text.replace(/\bmonths\b/gi, (selectedText ? selectedText + ' ' : '') + 'months');
    if (text !== label.textContent) label.textContent = text;
  }

  function onSubmitButtonEnabled() {
    freeBonusInjected = false;
    freeBonusOnetimeInjected = false;
    freeBonusPending = false;
    tipsRowInjected = false;
    runLoopCustomization();
    var delays = [100, 400, 900];
    delays.forEach(function (delay) {
      setTimeout(runLoopCustomization, delay);
    });
  }

  var submitObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type !== 'attributes' || mutation.attributeName !== 'disabled') return;
      var el = mutation.target;
      if (!el || !el.classList || !el.classList.contains('product-form__submit')) return;
      if (!el.hasAttribute('disabled') && !el.disabled) {
        onSubmitButtonEnabled();
      }
    });
  });
  function observeSubmitButton() {
    try {
      var btn = document.querySelector('.product-form__submit');
      if (!btn || btn.getAttribute('data-loop-submit-observed')) return;
      btn.setAttribute('data-loop-submit-observed', '1');
      submitObserver.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    } catch (e) { }
  }

  var loopSwitchClickInitialized = false;
  function initLoopPurchaseOptionSwitchClicks() {
    if (loopSwitchClickInitialized) return;
    loopSwitchClickInitialized = true;
    document.body.addEventListener('click', function (e) {
      var radioEl = e.target && e.target.closest && e.target.closest('.loop-widget-purchase-option-radio');
      if (!radioEl) return;
      var optionRow = radioEl.closest('.loop-widget-purchase-option');
      if (!optionRow) return;
      e.preventDefault();
      e.stopPropagation();
      optionRow.click();
    }, true);
  }

  function runLoopCustomization() {
    initLoopPurchaseOptionSwitchClicks();
    injectTipsRow();
    injectFreeBonus();
    injectPurchaseOptionBadge();
    updateLoopSelectorLabel();
    observeLoopLabel();
    observeSubmitButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runLoopCustomization);
  } else {
    runLoopCustomization();
  }

  const observer = new MutationObserver(function () {
    injectTipsRow();
    injectPurchaseOptionBadge();
    updateLoopSelectorLabel();
    if (freeBonusInjected) return;
    const container = document.querySelector('.loop-widget-spg-container');
    if (container && !container.nextElementSibling?.classList.contains('loop-widget-free-bonus')) {
      injectFreeBonus();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () {
    observer.disconnect();
  }, 15000);

  var labelObserver = new MutationObserver(function () {
    updateLoopSelectorLabel();
  });
  function observeLoopLabel() {
    var btnContainer = document.querySelector('.loop-widget-sp-button-container');
    if (!btnContainer) return;
    if (btnContainer.getAttribute('data-loop-label-observed')) return;
    btnContainer.setAttribute('data-loop-label-observed', '1');
    labelObserver.observe(btnContainer, { attributes: true, attributeFilter: ['class'], subtree: true });
    var priceEl = document.querySelector('.loop-widget-purchase-option-price');
    if (priceEl) labelObserver.observe(priceEl, { characterData: true, childList: true, subtree: true });
    updateLoopSelectorLabel();
    if (labelObserveInterval) {
      clearInterval(labelObserveInterval);
      labelObserveInterval = 0;
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeLoopLabel);
  } else {
    observeLoopLabel();
  }
  labelObserveInterval = setInterval(observeLoopLabel, 500);

  window.addEventListener('product-section-reloaded', function () {
    freeBonusInjected = false;
    freeBonusOnetimeInjected = false;
    freeBonusPending = false;
    tipsRowInjected = false;
    purchaseOptionBadgeInjected = false;
    runLoopCustomization();
    var delays = [100, 400, 900, 1600];
    delays.forEach(function (delay) {
      setTimeout(runLoopCustomization, delay);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSubmitButton);
  } else {
    observeSubmitButton();
  }
  document.addEventListener('product-section-reloaded', function () {
    submitObserver.disconnect();
    var btns = document.querySelectorAll('.product-form__submit');
    btns.forEach(function (btn) {
      btn.removeAttribute('data-loop-submit-observed');
    });
    setTimeout(observeSubmitButton, 50);
  });
})();

// TO RESTORE adding add-on products to cart immediately, comment this IIFE and uncomment the IIFE under it //
(function initBuildYourOwnKitAddonButtons() {
  var ADDON_BTN_SELECTOR = '.bundle-selector__add-btn.build-your-own-kit-add-on__add-btn';
  var pendingAddonVariantIds = {};
  var KIT4_ONETIME_GIFT_VARIANT_IDS = ['52947262341387', '52947267682571'];
  var KIT2_KIT3_GIFT_VARIANT_IDS = ['52947262341387'];
  var addonCleanupInProgress = false;

  function getAllAddonButtons() {
    return Array.prototype.slice.call(document.querySelectorAll(ADDON_BTN_SELECTOR), 0);
  }

  function getAddonBtn(el) {
    return el && el.closest ? el.closest(ADDON_BTN_SELECTOR) : null;
  }

  function setButtonLoading(btn, loading) {
    if (loading) {
      btn.classList.add('loading');
      var spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      btn.classList.remove('loading');
      var spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  var ADDED_CLASS = 'build-your-own-kit-add-on__add-btn--added';

  function setButtonAddedState(btn, added, keyOrPending) {
    var textEl = btn.querySelector('.build-your-own-kit-add-on__add-btn-text');
    if (textEl) textEl.textContent = added ? 'ADDED' : 'ADD+';
    if (added) btn.classList.add(ADDED_CLASS); else btn.classList.remove(ADDED_CLASS);
    if (keyOrPending && keyOrPending !== 'pending') {
      btn.setAttribute('data-addon-line-key', keyOrPending);
      btn.removeAttribute('data-addon-pending');
    } else if (keyOrPending === 'pending') {
      btn.setAttribute('data-addon-pending', '1');
      btn.removeAttribute('data-addon-line-key');
    } else {
      btn.removeAttribute('data-addon-line-key');
      btn.removeAttribute('data-addon-pending');
    }
  }

  function getEffectiveCartCount(cartData) {
    if (!cartData || typeof cartData.item_count === 'undefined') return 0;
    var count = cartData.item_count;
    if (!cartData.items || !cartData.items.length) return count;
    for (var i = 0; i < cartData.items.length; i++) {
      var vid = String(cartData.items[i].variant_id);
      for (var j = 0; j < KIT4_ONETIME_GIFT_VARIANT_IDS.length; j++) {
        if (vid === KIT4_ONETIME_GIFT_VARIANT_IDS[j]) {
          count -= (cartData.items[i].quantity || 1);
          break;
        }
      }
    }
    return count < 0 ? 0 : count;
  }

  function updateCartCountBubble(cartData) {
    var count = getEffectiveCartCount(cartData);
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      var span = bubble.querySelector('span[aria-hidden="true"]');
      if (span) span.textContent = count > 0 && count < 100 ? String(count) : '';
      bubble.style.display = count > 0 ? '' : 'none';
    });
    var notifBtn = document.getElementById('cart-notification-button');
    if (notifBtn && /\d+/.test(notifBtn.textContent)) {
      notifBtn.textContent = notifBtn.textContent.replace(/\d+/, String(count));
    }
  }

  /** If kit products are not in cart but gift variants are, remove orphaned gift items. Returns promise of { data, didCleanup }. */
  function cleanupGiftItemsWhenKit4Removed(cartData) {
    if (!cartData || !cartData.items || !cartData.items.length) return Promise.resolve({ data: cartData, didCleanup: false });
    var hasKit4 = cartData.items.some(function (item) {
      var handle = (item.handle || item.product_handle || '').toString();
      return handle === 'build-your-own-kit-4';
    });
    if (hasKit4) return Promise.resolve({ data: cartData, didCleanup: false });
    var hasKit2or3 = cartData.items.some(function (item) {
      var handle = (item.handle || item.product_handle || '').toString();
      return handle === 'build-your-own-kit-2' || handle === 'build-your-own-kit-3';
    });
    var toRemove = [];
    for (var i = 0; i < cartData.items.length; i++) {
      var vid = String(cartData.items[i].variant_id);
      for (var j = 0; j < KIT4_ONETIME_GIFT_VARIANT_IDS.length; j++) {
        if (vid === KIT4_ONETIME_GIFT_VARIANT_IDS[j]) {
          // Air freshener (52947262341387) belongs to Kit-2/Kit-3 subscriptions too — don't remove it if they're in cart
          if (hasKit2or3 && vid === KIT2_KIT3_GIFT_VARIANT_IDS[0]) break;
          toRemove.push({ key: cartData.items[i].key });
          break;
        }
      }
    }
    if (toRemove.length === 0) return Promise.resolve({ data: cartData, didCleanup: false });
    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    var runNext = function (idx) {
      if (idx >= toRemove.length) {
        var url = (window.routes && window.routes.cart_url) ? window.routes.cart_url + '.js' : '/cart.js';
        return fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          return { data: data, didCleanup: true };
        });
      }
      return fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: toRemove[idx].key, quantity: 0 }),
      })
        .then(function () { return runNext(idx + 1); });
    };
    return runNext(0);
  }

  function deduplicateGiftItems(cartData) {
    if (!cartData || !cartData.items || !cartData.items.length) return Promise.resolve({ data: cartData, didCleanup: false });
    var toReduce = [];
    for (var i = 0; i < cartData.items.length; i++) {
      var vid = String(cartData.items[i].variant_id);
      if (KIT4_ONETIME_GIFT_VARIANT_IDS.indexOf(vid) !== -1 && cartData.items[i].quantity > 1) {
        toReduce.push({ key: cartData.items[i].key });
      }
    }
    if (toReduce.length === 0) return Promise.resolve({ data: cartData, didCleanup: false });
    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    var runNext = function (idx) {
      if (idx >= toReduce.length) {
        var url = (window.routes && window.routes.cart_url) ? window.routes.cart_url + '.js' : '/cart.js';
        return fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          return { data: data, didCleanup: true };
        });
      }
      return fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: toReduce[idx].key, quantity: 1 }),
      }).then(function () { return runNext(idx + 1); });
    };
    return runNext(0);
  }

  /**
   * Removes one add-on row with a loading spinner, then recurses for the next.
   * Self-contained: does not depend on cart-items.updateQuantity() internals.
   */
  function removeAddonWithFeedback(cartItemsEl, lineNum) {
    var mainCartEl = document.getElementById('main-cart-items');
    if (mainCartEl) mainCartEl.classList.add('cart__items--disabled');
    var spinnerEl = cartItemsEl.querySelector('#CartItem-' + lineNum + ' .loading__spinner');
    if (spinnerEl) spinnerEl.classList.remove('hidden');

    function finish() {
      addonCleanupInProgress = false;
      if (mainCartEl) mainCartEl.classList.remove('cart__items--disabled');
      if (spinnerEl) spinnerEl.classList.add('hidden');
    }

    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    var sectionsToRender = [];
    try { sectionsToRender = cartItemsEl.getSectionsToRender(); } catch (e) { }

    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: lineNum,
        quantity: 0,
        sections: sectionsToRender.map(function (s) { return s.section; }),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (parsedState) {
        // Mirror what cart-items.updateQuantity does: re-render all sections
        sectionsToRender.forEach(function (section) {
          try {
            var html = parsedState.sections && parsedState.sections[section.section];
            if (!html) return;
            var el = document.getElementById(section.id);
            if (!el) return;
            var target = el.querySelector(section.selector) || el;
            var source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
            if (source) target.innerHTML = source.innerHTML;
          } catch (e) { }
        });

        var effectiveCount = typeof getCartEffectiveItemCount === 'function'
          ? getCartEffectiveItemCount(parsedState)
          : (parsedState.item_count || 0);
        cartItemsEl.classList.toggle('is-empty', effectiveCount === 0);
        var footer = document.getElementById('main-cart-footer');
        if (footer) footer.classList.toggle('is-empty', effectiveCount === 0);
        updateCartCountBubble(parsedState);
        syncAddonButtonsWithCart(parsedState);

        // Hide current row's spinner (row may already be gone from DOM after re-render)
        if (spinnerEl) spinnerEl.classList.add('hidden');

        // Find the next add-on in the updated cart data and continue cascade
        var nextLine = -1;
        if (parsedState.items) {
          for (var j = 0; j < parsedState.items.length; j++) {
            var p = parsedState.items[j].properties || {};
            if (String(p._addon) === '1') { nextLine = j + 1; break; }
          }
        }
        if (nextLine > 0) {
          var nextEl = document.querySelector('cart-items');
          if (nextEl && nextEl.tagName.toUpperCase() === 'CART-ITEMS') {
            removeAddonWithFeedback(nextEl, nextLine); // addonCleanupInProgress stays true
            return;
          }
        }
        finish();
      })
      .catch(function () { finish(); });
  }

  /** If no build-your-own-kit product remains in cart but add-on items (properties._addon=1) do, remove them. */
  function cleanupAddonItemsWhenKitRemoved(cartData) {
    if (!cartData || !cartData.items || !cartData.items.length) return Promise.resolve({ data: cartData, didCleanup: false });
    var hasKit = cartData.items.some(function (item) {
      var handle = (item.handle || item.product_handle || '').toString();
      return handle.indexOf('build-your-own-kit') === 0;
    });
    if (hasKit) return Promise.resolve({ data: cartData, didCleanup: false });

    var firstAddonLine = -1;
    for (var i = 0; i < cartData.items.length; i++) {
      var props = cartData.items[i].properties || {};
      if (String(props._addon) === '1') { firstAddonLine = i + 1; break; }
    }
    if (firstAddonLine === -1) return Promise.resolve({ data: cartData, didCleanup: false });

    // On the cart page: visual cascade with loaders via removeAddonWithFeedback.
    var cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl && cartItemsEl.tagName.toUpperCase() === 'CART-ITEMS') {
      if (!addonCleanupInProgress) {
        addonCleanupInProgress = true;
        removeAddonWithFeedback(cartItemsEl, firstAddonLine);
      }
      return Promise.resolve({ data: cartData, didCleanup: false });
    }

    // Not on the cart page: silent background API cleanup for all add-ons at once.
    var toRemove = [];
    for (var j = 0; j < cartData.items.length; j++) {
      var p = cartData.items[j].properties || {};
      if (String(p._addon) === '1') { toRemove.push({ key: cartData.items[j].key }); }
    }
    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    var runNext = function (idx) {
      if (idx >= toRemove.length) {
        var url = (window.routes && window.routes.cart_url) ? window.routes.cart_url + '.js' : '/cart.js';
        return fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          return { data: data, didCleanup: true };
        });
      }
      return fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: toRemove[idx].key, quantity: 0 }),
      }).then(function () { return runNext(idx + 1); });
    };
    return runNext(0);
  }

  function syncAddonButtonsWithCart(cartData) {
    var buttons = getAllAddonButtons();
    if (!cartData || !cartData.items || !cartData.items.length) {
      buttons.forEach(function (btn) {
        var form = btn.closest('form.build-your-own-kit-add-on__form');
        var variantId = form && form.querySelector('input[name="id"]') ? String(form.querySelector('input[name="id"]').value) : '';
        if (pendingAddonVariantIds[variantId]) {
          setButtonAddedState(btn, true, 'pending');
        } else {
          setButtonAddedState(btn, false);
        }
      });
      return;
    }
    buttons.forEach(function (btn) {
      var form = btn.closest('form.build-your-own-kit-add-on__form');
      if (!form) return;
      var variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput) return;
      var variantId = String(variantIdInput.value);
      var textEl = btn.querySelector('.build-your-own-kit-add-on__add-btn-text');
      if (!textEl) return;
      var found = null;
      for (var i = 0; i < cartData.items.length; i++) {
        if (String(cartData.items[i].variant_id) === variantId) {
          found = cartData.items[i];
          break;
        }
      }
      if (found) {
        setButtonAddedState(btn, true, found.key);
      } else if (pendingAddonVariantIds[variantId]) {
        setButtonAddedState(btn, true, 'pending');
      } else {
        setButtonAddedState(btn, false);
      }
    });
  }

  function fetchCartAndSync() {
    var url = (window.routes && window.routes.cart_url) ? window.routes.cart_url + '.js' : '/cart.js';
    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) { return deduplicateGiftItems(data); })
      .then(function (result) { return cleanupGiftItemsWhenKit4Removed(result.data).then(function (r2) {
        return { data: r2.data, didCleanup: result.didCleanup || r2.didCleanup };
      }); })
      .then(function (result) {
        return cleanupAddonItemsWhenKitRemoved(result.data).then(function (r2) {
          return { data: r2.data, didCleanup: result.didCleanup || r2.didCleanup };
        });
      })
      .then(function (result) {
        syncAddonButtonsWithCart(result.data);
        updateCartCountBubble(result.data);
        if (result.didCleanup && typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'build-your-own-kit-addon', cartData: result.data });
        }
      })
      .catch(function () { });
  }

  document.addEventListener('click', function (e) {
    var btn = getAddonBtn(e.target);
    if (!btn) return;

    var textEl = btn.querySelector('.build-your-own-kit-add-on__add-btn-text');
    if (!textEl) return;

    var lineKey = btn.getAttribute('data-addon-line-key');
    var isPending = btn.getAttribute('data-addon-pending') === '1';

    if (lineKey) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      btn.setAttribute('aria-disabled', 'true');
      setButtonLoading(btn, true);
      var body = JSON.stringify({ id: lineKey, quantity: 0 });
      fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body,
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          updateCartCountBubble(data);
          syncAddonButtonsWithCart(data);
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'build-your-own-kit-addon', cartData: data });
          }
        })
        .catch(function () { })
        .finally(function () {
          btn.removeAttribute('aria-disabled');
          setButtonLoading(btn, false);
        });
      return;
    }

    if (isPending) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var form = btn.closest('form.build-your-own-kit-add-on__form');
      if (!form) return;
      var variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput) return;
      var variantId = variantIdInput.value;
      delete pendingAddonVariantIds[variantId];
      setButtonAddedState(btn, false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var form = btn.closest('form.build-your-own-kit-add-on__form');
    if (!form) return;
    var variantIdInput = form.querySelector('input[name="id"]');
    if (!variantIdInput) return;
    var variantId = variantIdInput.value;
    if (!variantId) return;

    pendingAddonVariantIds[variantId] = true;
    setButtonAddedState(btn, true, 'pending');
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.tagName && form.tagName.toUpperCase() !== 'FORM') return;
    var submitBtn = form && form.querySelector('.product-form__submit');
    if (!submitBtn || !form) return;

    var pendingIds = Object.keys(pendingAddonVariantIds);
    var pathname = (typeof window.location !== 'undefined' && window.location.pathname) || '';
    var isKit4 = pathname.indexOf('/products/build-your-own-kit-4') !== -1;
    var isKit2or3 = pathname.indexOf('/products/build-your-own-kit-2') !== -1 || pathname.indexOf('/products/build-your-own-kit-3') !== -1;
    var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    var isSubscription = sellingPlanInput && (sellingPlanInput.value || '') !== '';
    var giftIds = isKit4 ? KIT4_ONETIME_GIFT_VARIANT_IDS : (isKit2or3 && isSubscription ? KIT2_KIT3_GIFT_VARIANT_IDS : []);
    var extraVariantIds = giftIds.concat(pendingIds);
    if (extraVariantIds.length === 0) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('loading');
    var spinner = submitBtn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement && cart.setActiveElement(document.activeElement);
    }
    var config = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/json' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(cartAddUrl, config)
      .then(function (res) { return res.json(); })
      .then(function (mainResponse) {
        if (mainResponse.status && mainResponse.status !== 200) {
          submitBtn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          submitBtn.removeAttribute('aria-disabled');
          return;
        }
        var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url + '.js' : '/cart.js';
        return fetch(cartUrl)
          .then(function (r) { return r.json(); })
          .then(function (currentCart) {
            var existingVids = (currentCart.items || []).map(function (item) { return String(item.variant_id); });
            var filteredGiftIds = giftIds.filter(function (id) { return existingVids.indexOf(String(id)) === -1; });
            var actualVariantIds = filteredGiftIds.concat(pendingIds);
            var addNext = function (index) {
              if (index >= actualVariantIds.length) {
                if (pendingIds.length > 0) pendingIds.forEach(function (id) { delete pendingAddonVariantIds[id]; });
                if (cart && typeof cart.renderContents === 'function') cart.renderContents(mainResponse);
                if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
                  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'build-your-own-kit-addon', cartData: mainResponse });
                }
                fetchCartAndSync();
                submitBtn.classList.remove('loading');
                if (spinner) spinner.classList.add('hidden');
                submitBtn.removeAttribute('aria-disabled');
                return;
              }
              var fd = new FormData();
              fd.append('id', actualVariantIds[index]);
              fd.append('quantity', '1');
              if (pendingIds.indexOf(String(actualVariantIds[index])) !== -1) {
                fd.append('properties[_addon]', '1');
              }
              var cfg = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/json' } };
              cfg.headers = cfg.headers || {};
              cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete cfg.headers['Content-Type'];
              cfg.body = fd;
              fetch(cartAddUrl, cfg)
                .then(function (r) { return r.json(); })
                .then(function () { addNext(index + 1); })
                .catch(function () { addNext(index + 1); });
            };
            addNext(0);
          });
      })
      .catch(function () {
        submitBtn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        submitBtn.removeAttribute('aria-disabled');
      });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndSync);
  } else {
    fetchCartAndSync();
  }
  window.addEventListener('product-section-reloaded', function () {
    setTimeout(fetchCartAndSync, 100);
  });
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      fetchCartAndSync();
    });
  }
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      fetchCartAndSync();
    }
  });
})();

/** Add-on ADD+ buttons use <product-form> (immediate cart/add). Deferred-queue behavior archived in assets/build-your-own-kit-addon-deferred-queue.js.archive */
// (function initBuildYourOwnKitKit4GiftsAndCartBubble() {
//   var KIT4_ONETIME_GIFT_VARIANT_IDS = ['52947262341387', '52947267682571'];

//   function getEffectiveCartCount(cartData) {
//     if (!cartData || typeof cartData.item_count === 'undefined') return 0;
//     var count = cartData.item_count;
//     if (!cartData.items || !cartData.items.length) return count;
//     for (var i = 0; i < cartData.items.length; i++) {
//       var vid = String(cartData.items[i].variant_id);
//       for (var j = 0; j < KIT4_ONETIME_GIFT_VARIANT_IDS.length; j++) {
//         if (vid === KIT4_ONETIME_GIFT_VARIANT_IDS[j]) {
//           count -= (cartData.items[i].quantity || 1);
//           break;
//         }
//       }
//     }
//     return count < 0 ? 0 : count;
//   }

//   function updateCartCountBubble(cartData) {
//     var count = getEffectiveCartCount(cartData);
//     document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
//       var span = bubble.querySelector('span[aria-hidden="true"]');
//       if (span) span.textContent = count > 0 && count < 100 ? String(count) : '';
//       bubble.style.display = count > 0 ? '' : 'none';
//     });
//   }

//   /** If kit-4 is not in cart but gift variants are, remove gift items. Returns promise of { data, didCleanup }. */
//   function cleanupGiftItemsWhenKit4Removed(cartData) {
//     if (!cartData || !cartData.items || !cartData.items.length) return Promise.resolve({ data: cartData, didCleanup: false });
//     var hasKit4 = cartData.items.some(function (item) {
//       var handle = (item.handle || item.product_handle || '').toString();
//       return handle === 'build-your-own-kit-4';
//     });
//     if (hasKit4) return Promise.resolve({ data: cartData, didCleanup: false });
//     var toRemove = [];
//     for (var i = 0; i < cartData.items.length; i++) {
//       var vid = String(cartData.items[i].variant_id);
//       for (var j = 0; j < KIT4_ONETIME_GIFT_VARIANT_IDS.length; j++) {
//         if (vid === KIT4_ONETIME_GIFT_VARIANT_IDS[j]) {
//           toRemove.push({ key: cartData.items[i].key });
//           break;
//         }
//       }
//     }
//     if (toRemove.length === 0) return Promise.resolve({ data: cartData, didCleanup: false });
//     var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
//     var runNext = function (idx) {
//       if (idx >= toRemove.length) {
//         var url = (window.routes && window.routes.cart_url) ? window.routes.cart_url + '.js' : '/cart.js';
//         return fetch(url).then(function (r) { return r.json(); }).then(function (data) {
//           return { data: data, didCleanup: true };
//         });
//       }
//       return fetch(changeUrl, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ id: toRemove[idx].key, quantity: 0 }),
//       })
//         .then(function () { return runNext(idx + 1); });
//     };
//     return runNext(0);
//   }

//   function fetchCartAndSync() {
//     var url = (window.routes && window.routes.cart_url) ? window.routes.cart_url + '.js' : '/cart.js';
//     fetch(url)
//       .then(function (res) { return res.json(); })
//       .then(function (data) { return cleanupGiftItemsWhenKit4Removed(data); })
//       .then(function (result) {
//         updateCartCountBubble(result.data);
//         if (result.didCleanup && typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
//           publish(PUB_SUB_EVENTS.cartUpdate, { source: 'build-your-own-kit-addon', cartData: result.data });
//         }
//       })
//       .catch(function () { });
//   }

//   document.addEventListener('submit', function (e) {
//     var form = e.target;
//     if (form && form.tagName && form.tagName.toUpperCase() !== 'FORM') return;
//     var submitBtn = form && form.querySelector('.product-form__submit');
//     if (!submitBtn || !form) return;

//     var isKit4Onetime = false;
//     if (typeof window.location !== 'undefined' && window.location.pathname && window.location.pathname.indexOf('/products/build-your-own-kit-4') !== -1) {
//       var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
//       if (sellingPlanInput && (sellingPlanInput.value || '') === '') isKit4Onetime = true;
//     }
//     var extraVariantIds = isKit4Onetime ? KIT4_ONETIME_GIFT_VARIANT_IDS.slice() : [];
//     if (extraVariantIds.length === 0) return;

//     e.preventDefault();
//     e.stopPropagation();
//     e.stopImmediatePropagation();

//     submitBtn.setAttribute('aria-disabled', 'true');
//     submitBtn.classList.add('loading');
//     var spinner = submitBtn.querySelector('.loading__spinner');
//     if (spinner) spinner.classList.remove('hidden');

//     var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//     var formData = new FormData(form);
//     if (cart && typeof cart.getSectionsToRender === 'function') {
//       formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
//       formData.append('sections_url', window.location.pathname);
//       cart.setActiveElement && cart.setActiveElement(document.activeElement);
//     }
//     var config = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/json' } };
//     config.headers = config.headers || {};
//     config.headers['X-Requested-With'] = 'XMLHttpRequest';
//     delete config.headers['Content-Type'];
//     config.body = formData;

//     var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

//     fetch(cartAddUrl, config)
//       .then(function (res) { return res.json(); })
//       .then(function (mainResponse) {
//         if (mainResponse.status && mainResponse.status !== 200) {
//           submitBtn.classList.remove('loading');
//           if (spinner) spinner.classList.add('hidden');
//           submitBtn.removeAttribute('aria-disabled');
//           return;
//         }
//         var addNext = function (index) {
//           if (index >= extraVariantIds.length) {
//             if (cart && typeof cart.renderContents === 'function') cart.renderContents(mainResponse);
//             if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
//               publish(PUB_SUB_EVENTS.cartUpdate, { source: 'build-your-own-kit-addon', cartData: mainResponse });
//             }
//             fetchCartAndSync();
//             submitBtn.classList.remove('loading');
//             if (spinner) spinner.classList.add('hidden');
//             submitBtn.removeAttribute('aria-disabled');
//             return;
//           }
//           var fd = new FormData();
//           fd.append('id', extraVariantIds[index]);
//           fd.append('quantity', '1');
//           var cfg = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/json' } };
//           cfg.headers = cfg.headers || {};
//           cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
//           delete cfg.headers['Content-Type'];
//           cfg.body = fd;
//           fetch(cartAddUrl, cfg)
//             .then(function (r) { return r.json(); })
//             .then(function () { addNext(index + 1); })
//             .catch(function () { addNext(index + 1); });
//         };
//         addNext(0);
//       })
//       .catch(function () {
//         submitBtn.classList.remove('loading');
//         if (spinner) spinner.classList.add('hidden');
//         submitBtn.removeAttribute('aria-disabled');
//       });
//   }, true);

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', fetchCartAndSync);
//   } else {
//     fetchCartAndSync();
//   }
//   window.addEventListener('product-section-reloaded', function () {
//     setTimeout(fetchCartAndSync, 100);
//   });
//   if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
//     subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
//       fetchCartAndSync();
//     });
//   }
//   window.addEventListener('pageshow', function (event) {
//     var cartNotification = document.querySelector('cart-notification');
//     if (cartNotification && typeof cartNotification.close === 'function') {
//       cartNotification.close();
//     }
//     if (event.persisted) {
//       fetchCartAndSync();
//     }
//   });
// })();
